// intended to be used for navigating to legacy PHP pages
// and designed as a drop-in replacement for
// `useNavigate` from `react-router-dom`
export function useLegacyNavigate() {
  return (route: string) => {
    window.location.href = route;
  };
}
